import { useFetcher } from '@remix-run/react';
import type { FetcherData } from 'types';

import ErrorIcon from '~/assets/icons/Error';
import { Button } from '~/components/Button';
import TextInput from '~/components/Form/TextInput';

import ModalHeadings from './ModalHeadings';

const ErrorMessage = ({ isActive }: { isActive: boolean }) => {
  return isActive ? (
    <div className="flex h-5 flex-row content-center items-center gap-1">
      <ErrorIcon />
      <p className="text-xs font-bold text-red-600">
        There is currently no account associated to this email
      </p>
    </div>
  ) : (
    <></>
  );
};

const ForgotPasswordScreen = () => {
  const fetcher = useFetcher<FetcherData>();

  const errors = fetcher.data?.errors;
  const success = fetcher.data?.success;
  const submitting = fetcher.state === 'submitting';

  return (
    <>
      <ModalHeadings>
        Please enter your email to start password recovery
      </ModalHeadings>
      <div className="flex w-full flex-col items-start gap-4 bg-black">
        <fetcher.Form
          action="/bolt/reset-password/"
          className="flex size-full flex-col items-start gap-4"
          method="post"
        >
          <TextInput
            className="h-12 w-full rounded-md p-4"
            error={
              errors?.email ? 'This is an incorrect email format' : undefined
            }
            id="password-reset-email"
            name="email"
            placeholder="Email address"
            type="email"
          />
          <Button
            className="h-12"
            variant={success ? 'disabled' : 'green-human'}
            disabled={success}
          >
            {submitting ? 'Resetting...' : 'Reset password'}
          </Button>
          <ErrorMessage isActive={Boolean(errors?.notFound)} />
          {success && (
            <p className="text-base text-white">
              Please check your email inbox (and junk mail too) for further
              instructions.
            </p>
          )}
        </fetcher.Form>
      </div>
    </>
  );
};

export default ForgotPasswordScreen;
